<template>
  <div class="filter">
    <div class="form-control">
      <input type="text" placeholder="Введите имя" v-model="name" autocomplete="off">
    </div>
    <div class="form-control">
      <input type="text" placeholder="Введите номер договора" v-model="contract" autocomplete="off">
    </div>
    <div class="form-control">
      <input type="text" placeholder="Введите адрес" v-model="address" autocomplete="off">
    </div>
    <div class="form-control">
      <input type="text" placeholder="Введите телефон" v-model="phone" autocomplete="off">
    </div>
    <div class="form-control">
      <input type="text" placeholder="Введите дату окончания договора. Формат: ГГГГ-ММ. (Пример: 2030-10)" v-model="valid" autocomplete="off">
    </div>
    <div class="form-control">
      <label for="trest">Трест</label>
      <select id="trest" v-model="trest">
        <option value="">Не выбран</option>
        <optgroup label="----------"></optgroup>
        <option value="МОСКВА">МОСКВА</option>
        <option value="ПОДОЛЬСК">ПОДОЛЬСК</option>
        <option value="ОДИНЦОВО">ОДИНЦОВО</option>
        <option value="НОГИНСК">НОГИНСК</option>
        <option value="МЫТИЩИ">МЫТИЩИ</option>
        <option value="КРАСНОГОРСК">КРАСНОГОРСК</option>
        <option value="КОЛОМНА">КОЛОМНА</option>
        <optgroup label="----------"></optgroup>
        <optgroup label="МОСКВА">
          <option value="МОСКВА-москва">Москва</option>
        </optgroup>
        <optgroup label="ПОДОЛЬСК">
          <option value="ПОДОЛЬСК-подольск">Подольск</option>
          <option value="ПОДОЛЬСК-ступино">Ступино</option>
          <option value="ПОДОЛЬСК-серебряные пруды">Серебряные пруды</option>
          <option value="ПОДОЛЬСК-михнево">Михнево</option>
          <option value="ПОДОЛЬСК-зарайск">Зарайск</option>
          <option value="ПОДОЛЬСК-кашира">Кашира</option>
          <option value="ПОДОЛЬСК-видное">Видное</option>
          <option value="ПОДОЛЬСК-столбовая">Столбовая</option>
          <option value="ПОДОЛЬСК-чехов">Чехов</option>
          <option value="ПОДОЛЬСК-Домодедово">Домодедово</option>
          <option value="ПОДОЛЬСК-серпухов">Серпухов</option>
          <option value="ПОДОЛЬСК-климовск">Климовск</option>
        </optgroup>
        <optgroup label="ОДИНЦОВО">
          <option value="ОДИНЦОВО-одинцово">Одинцово</option>
          <option value="ОДИНЦОВО-апрелевка">Апрелевка</option>
          <option value="ОДИНЦОВО-щербинка">Щербинка</option>
          <option value="ОДИНЦОВО-вороново">Вороново</option>
          <option value="ОДИНЦОВО-троицк">Троицк</option>
          <option value="ОДИНЦОВО-верея">Верея</option>
          <option value="ОДИНЦОВО-наро-фоминск">Наро-Фоминск</option>
          <option value="ОДИНЦОВО-голицино">Голицино</option>
          <option value="ОДИНЦОВО-можайск">Можайск</option>
          <option value="ОДИНЦОВО-руза">Руза</option>
          <option value="ОДИНЦОВО-барвиха">Барвиха</option>
          <option value="ОДИНЦОВО-кубинка">Кубинка</option>
        </optgroup>
        <optgroup label="НОГИНСК">
          <option value="НОГИНСК-ногинск">Ногинск</option>
          <option value="НОГИНСК-балашиха">Балашиха</option>
          <option value="НОГИНСК-фрязино">Фрязино</option>
          <option value="НОГИНСК-лосино-петровский">Лосино-Петровский</option>
          <option value="НОГИНСК-щёлково">Щёлково</option>
          <option value="НОГИНСК-рошаль">Рошаль</option>
          <option value="НОГИНСК-салтыковка">Салтыковка</option>
          <option value="НОГИНСК-шатура">Шатура</option>
          <option value="НОГИНСК-куровское">Куровское</option>
          <option value="НОГИНСК-ликино-дулево">Ликино-Дулево</option>
          <option value="НОГИНСК-орехово-зуево">Орехово-Зуево</option>
          <option value="НОГИНСК-электроугли">Электроугли</option>
          <option value="НОГИНСК-павлово-посад">Павлово-Посад</option>
          <option value="НОГИНСК-электросталь">Электросталь</option>
        </optgroup>
        <optgroup label="МЫТИЩИ">
          <option value="МЫТИЩИ-мытищи">Мытищи</option>
          <option value="МЫТИЩИ-катуар">Катуар</option>
          <option value="МЫТИЩИ-дубна">Дубна</option>
          <option value="МЫТИЩИ-талдом">Талдом</option>
          <option value="МЫТИЩИ-братовщина">Братовщина</option>
          <option value="МЫТИЩИ-сергиев-посад">Сергиев-Посад</option>
          <option value="МЫТИЩИ-пушкино">Пушкино</option>
          <option value="МЫТИЩИ-хотьково">Хотьково</option>
          <option value="МЫТИЩИ-королёв">Королёв</option>
        </optgroup>
        <optgroup label="КРАСНОГОРСК">
          <option value="КРАСНОГОРСК-красногорск">Красногорск</option>
          <option value="КРАСНОГОРСК-химки">Химки</option>
          <option value="КРАСНОГОРСК-сходня">Сходня</option>
          <option value="КРАСНОГОРСК-долгопрудный">Долгопрудный</option>
          <option value="КРАСНОГОРСК-солнечногорск">Солнечногорск</option>
          <option value="КРАСНОГОРСК-клин">Клин</option>
          <option value="КРАСНОГОРСК-шаховская">Шаховская</option>
          <option value="КРАСНОГОРСК-лотошино">Лотошино</option>
          <option value="КРАСНОГОРСК-волоколамск">Волоколамс</option>
          <option value="КРАСНОГОРСК-дедовск">Дедовск</option>
          <option value="КРАСНОГОРСК-истра">Истра</option>
          <option value="КРАСНОГОРСК-нахабино">Нахабино</option>
        </optgroup>
        <optgroup label="КОЛОМНА">
          <option value="КОЛОМНА-коломна">Коломна</option>
          <option value="КОЛОМНА-люберцы">Люберцы</option>
          <option value="КОЛОМНА-малаховка">Малаховка</option>
          <option value="КОЛОМНА-озеры">Озеры</option>
          <option value="КОЛОМНА-быково">Быково</option>
          <option value="КОЛОМНА-бронницы">Бронницы</option>
          <option value="КОЛОМНА-электроизолятор">Электроизолятор</option>
          <option value="КОЛОМНА-жуковский">Жуковский</option>
          <option value="КОЛОМНА-раменское">Раменское</option>
          <option value="КОЛОМНА-егорьевск">Егорьевск</option>
          <option value="КОЛОМНА-луховицы">Луховицы</option>
          <option value="КОЛОМНА-воскресенск">Воскресенск</option>
        </optgroup>
      </select>
    </div>
  </div>
</template>

<script>
import {ref, watch} from 'vue'

export default {
  emits: ['update:modelValue'],
  props: ['modelValue'],
  setup(_, {emit}) {
    const name = ref()
    const contract = ref()
    const address = ref()
    const phone = ref()
    const valid = ref()
    const trest = ref()

    watch([name, contract, address, phone, valid, trest], values => {
      emit('update:modelValue', {
        name: values[0],
        contract: values[1],
        address: values[2],
        phone: values[3],
        valid: values[4],
        trest: values[5]

      })
    })

    return {
      name,
      contract,
      address,
      phone,
      valid,
      trest
    }
  }
}
</script>

<style scoped>

</style>